<template>
    <!-- <transition name="fade-down" appear> -->
        <footer class=" footer" :style="pcOnly ? '' : 'min-height: 150px'" :class="{light, fixed}">
            <!-- <v-row>
                <v-col cols="4"></v-col>
                <v-col cols="4"></v-col>
                <v-col cols="4"></v-col>
            </v-row> -->
            <div class="footer-content py-4 py-lg-8">
                <v-container>
                    <v-row :class="{'justify-space-between': pcOnly, 'flex-column justify-center': phoneOnly}">
                        <v-col :cols="pcOnly ? 3 : 12" :class="{'text-center': phoneOnly}">
                            <div class="mb-4">
                                <logo :medium="phoneOnly" white dark />
                            </div>
                            <div class="footer-text footer--text" :class="{'details-text': phoneOnly, 'medium-text': pcOnly}">
                            منصة الدكتور في الفيزياء لشرح مادة الفيزياء للثانوية العامة
                            </div>
                        </v-col>
                        <v-col v-if="pcOnly" :cols="pcOnly ? 3 : 12">
                            <div class="footer-links d-flex flex-column align-center" :class="{'justify-center': phoneOnly}">
                                <v-subheader class="mb-3" dark>الروابط</v-subheader>
                                <div v-for="(link, i) in links" :key="i">
                                    <v-btn active-class="e-active-btn" exact text :dark="!light" :to="link.to" class="mx-1">{{link.name}}</v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col :cols="pcOnly ? 2 : 12" class="text-center">
                            <template v-if="pcOnly">
                                <v-subheader class="justify-center mb-3" dark>تواصل معنا</v-subheader>
                                <v-btn color="secondary" outlined dark large block :to="{name: 'help'}">
                                    <v-icon left>mdi-help-circle-outline</v-icon>
                                    <span>الدعم الفني</span>
                                </v-btn>
                            </template>
                            <div class="my-4">
                                <social-btns />
                            </div>
                            <div class="my-4 d-flex ltr-dir flex-wrap">
                                <div v-if="appData.contact_phone" class="d-flex align-center ltr-dir ms-2">
                                    <v-avatar size="36" color="rgba(0, 0, 0, 0.3)" class="ms-2">
                                        <v-icon size="18" dark>mdi-phone</v-icon>
                                    </v-avatar>
                                    <div class="details-text ltr-dir">{{ appData.contact_phone }}</div>
                                </div>
                                <div v-if="appData.contact_email" class="d-flex align-center ltr-dir ms-2">
                                    <v-avatar size="36" color="rgba(0, 0, 0, 0.3)" class="ms-2">
                                        <v-icon size="18" dark>mdi-email</v-icon>
                                    </v-avatar>
                                    <div class="details-text ltr-dir">{{ appData.contact_email }}</div>
                                </div>
                            </div>


                            <v-divider dark class="my-5" />
                            <!-- <v-subheader class="justify-center mb-3" dark>{{$t('routes.help')}}</v-subheader> -->
                            <div v-if="!miniDerasaPlatform" class="d-flex justify-center align-center">
                                <store-badge type="playstore" width="120px" />
                                <store-badge type="appstore" width="94px" />
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <!-- <v-divider v-if="pcOnly" class="mb-3 grey" :class="{'darken-3': !light, 'lighten-2': light}" /> -->
            <div class="footer-watermark footer--text details-text py-4">
                <v-container class="d-flex align-center justify-center flex-column-reverse flex-lg-row"> <!--  :class="{'flex-column': phoneOnly, 'justify-space-between': pcOnly}" -->
    
                    <div class="rights-text text-center mt-3 mt-lg-0">
                        <div>جميع الحقوق محفوظة © 2024</div>
                    </div>

                    <div v-if="pcOnly" class="mx-3">|</div>

                    <div class="ltr-dir d-flex align-center">
                        <div class="footer--text details-text ms-2">Powered By: </div>
                        <a href="https://www.derasa.tech" :target="capRunning ? '_system' : '_blank'">
                            <img class="derasatech-logo" :src="asset('derasatech-logo/logo-white.png', 'img')" style="width: auto; height: 15px; opacity: 0.8"/>
                        </a>
                    </div>
                </v-container>
            </div>
            
        </footer>
    <!-- </transition> -->
</template>

<script>
// import appBadge from './store-badge'
import Logo from './logo'
import Links from '@/helpers/links'
import StoreBadge from '../default/store-badge'

import SocialBtns from './social-btns'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'e-footer',
    props: {
        light: {
            default: false,
            type: Boolean
        },
        fixed: {
            default: false,
            type: Boolean
        }
    },
    components: {
        Logo,
        SocialBtns,
        StoreBadge
    },
    data(){
        return {
            
        }
    },
    computed: {
        ...GlobalComputed,
        links(){
            return this.isAuthed ? Links.auth : Links.guest;
        }
    },
    methods: {
        ...GlobalMethods,
    },
}
</script>

<style lang="scss" scoped>
    footer{
        width: 100%;
        background: #121212;
        color: #fff;
        &.light{
            // background: rgb(236, 236, 236);
            background-color: #fff!important;
            background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgb(245, 245, 245) 200%);
            box-shadow: 0 -1px 4px 0 rgba(0,0,0, .1)!important;

            color: rgb(61, 61, 61);
        }
        &.fixed{
            @media(min-height: 900px){
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
    .app-download{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    @media (max-width: 960px){
        .footer-links, .v-divider{
            display: none;
        }
        .rights-text{
            font-size: 13px!important;
        }
    }

    .footer-watermark{
        background-color: rgba(0,0,0,.25);
        &, div{
            line-height: 1;
        }

    }
    .footer--text{
        color: rgb(231, 237, 255, 0.7);
    }
    .footer-links{
        .v-btn{
            color: rgb(231, 237, 255, 0.7);
            &.v-btn--active{
                opacity: 1;
                color: #fff;
                &::before{
                    opacity: 0!important;
                }
            }
            &:hover{
                opacity: 1;
            }
        }
    }
    .footer-text{
        line-height: 1.75rem;
        
        @media(min-width: 960px){
            line-height: 1.95rem;
        }
    }
</style>